export default function AppContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-base-300">
            <div className="bg-base-100 flex h-dvh flex-col md:mx-auto md:max-w-7xl">{children}</div>
        </div>
    )
}
